
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.812 2.833c.228-.484.442-.997.713-1.552.142-.256.328-.498.627-.527h4.691c.314.029.485.27.642.527.27.555.485 1.068.713 1.552H1.812zM3.152 0c-.499 0-.812.185-1.226.769l-.699 1.566H.157c-.156 0-.455.868.657.896l-.37.911c0 1.14.013 2.292.013 3.43A.42.42 0 00.885 8h1.44a.42.42 0 00.428-.427v-.954h5.49v.954c0 .242.2.427.427.427h1.455a.42.42 0 00.427-.427c0-1.139.015-2.292.015-3.43l-.385-.912c1.126-.028.813-.896.656-.896h-1.07L9.084.769C8.656.185 8.357 0 7.844 0H3.151zm5.832 4.214a.7.7 0 00-.699.697.7.7 0 001.398 0 .7.7 0 00-.699-.697zm-6.972 0a.7.7 0 01.698.697.7.7 0 01-1.397 0 .7.7 0 01.699-.697z","fill":"#1B0753"}})])
          )
        }
      }
    